import { render, staticRenderFns } from "./TenderListFullHeightHeaderCell.vue?vue&type=template&id=87b2e0dc&"
import script from "./TenderListFullHeightHeaderCell.vue?vue&type=script&lang=js&"
export * from "./TenderListFullHeightHeaderCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports